import React, { Component } from 'react';

class Map extends Component {

    componentDidMount() {
        // Ce code s'exécute quand le composant est monté
        let placeCard = document.querySelector('.place-card');

        if (placeCard) {
            let parentDiv = placeCard.closest('div');
            if (parentDiv) {
                parentDiv.classList.add('ma-nouvelle-classe');
            }
        }
    }

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';

        return (
            <div className="google-map mb-120">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3238.741975766864!2d-5.8547766244058055!3d35.73256377257062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd0b870024b22817%3A0x5c275337bb653286!2sMedesco%20-%20R%C3%A9sidence%20Diamantine!5e0!3m2!1sen!2sma!4v1750503206868!5m2!1sen!2sma"
                    width="100%"
                    height="100%"
                    frameBorder={0}
                    allowFullScreen
                    aria-hidden="false"
                    tabIndex={0}
                />
            </div>
        );
    }
}

export default Map;
